module.exports = __webpack_public_path__ + "static/media/15-marcozago-hovercolor.1ed9e458.jpg";